module.exports = __webpack_public_path__ + "img/19.e59b34e7.jpg";